import * as React from 'react';
import RuleNewPage from '../screens/RuleNewPage';
import RulesEditPage from '../screens/RulesEditPage';
import { ProtectedRoute, monitorRouterMatch } from '../../common/components';
import WrappedRuleConnectionEdit from '../screens/ConnectionEditPage';
import RulesListPage from '../screens/RulesListPage';
import { STORE_RULE_EDIT, STORE_RULES_EXTERNAL_CONNECTIONS, STORE_TAG_PREVIEW } from '../constants';
import ExternalConnectionListPage from '../screens/ExternalConnectionsListPage';
import RulesCopiedPipelinePage from '../screens/RulesCopiedPipelinePage';
import WrappedRuleConnectionAdd from '../screens/ConnectionAddPage';
import TagPreviewPage from '../screens/TagPreviewPage';
import RulePreviewPage from '../screens/RulePreviewPage';

export const RulesPagesNavigation = {
    RulesListPage: '/projects/:projectId/rules/list',
    RulesNewPage: '/projects/:projectId/:groupId/rules/new',
    RulesNewPageFromTag: '/projects/:projectId/:groupId/:tagId/rules/new',
    RulesNewPageWithCopiedPipeline: '/projects/:projectId/rules/copied/:groupId/:ruleId',
    RulesEditPage: '/projects/:projectId/rules/edit/:id/:isCopy',
    ExternalConnectionsAddPage: '/projects/:projectId/rules/externalConnections/add',
    ExternalConnectionsEditPage: '/projects/:projectId/rules/externalConnections/edit/:id',
    ExternalConnectionsListPage: '/projects/:projectId/rules/externalConnections/list',
    TagPreviewPage: '/projects/:id/tagPreview/:tag',
    RulesPreviewPage: '/projects/:projectId/rules/preview/:id/'
};

export default () => {
    return (
        <>
            <ProtectedRoute component={RulesListPage} path={RulesPagesNavigation.RulesListPage} />
            {/* <ProtectedRoute component={RuleNewPage} path={RulesPagesNavigation.RulesNewPage} /> */}
            <ProtectedRoute
                component={monitorRouterMatch(STORE_RULE_EDIT, (s, m) =>
                    s[STORE_RULE_EDIT].setCurrentGroupId(m!.params)
                )(RuleNewPage)}
                path={RulesPagesNavigation.RulesNewPage}
            />
            <ProtectedRoute
                component={monitorRouterMatch(STORE_RULE_EDIT, (s, m) =>
                    s[STORE_RULE_EDIT].setPreselectedData(m!.params)
                )(RuleNewPage)}
                path={RulesPagesNavigation.RulesNewPageFromTag}
            />
            <ProtectedRoute
                component={monitorRouterMatch(STORE_RULE_EDIT, (s, m) => {
                    s[STORE_RULE_EDIT].setMatch(m!.params);
                    s[STORE_RULE_EDIT].setPreselectedData(m!.params);
                })(RulesCopiedPipelinePage)}
                path={RulesPagesNavigation.RulesNewPageWithCopiedPipeline}
            />
            <ProtectedRoute
                component={monitorRouterMatch(STORE_RULE_EDIT, (s, m) => s[STORE_RULE_EDIT].setMatch(m!.params))(
                    RulesEditPage
                )}
                path={RulesPagesNavigation.RulesEditPage}
            />
            <ProtectedRoute
                component={ExternalConnectionListPage}
                path={RulesPagesNavigation.ExternalConnectionsListPage}
            />
            <ProtectedRoute
                component={monitorRouterMatch(STORE_RULES_EXTERNAL_CONNECTIONS, (s, m) =>
                    s[STORE_RULES_EXTERNAL_CONNECTIONS].setMatch(m!.params)
                )(WrappedRuleConnectionEdit)}
                path={RulesPagesNavigation.ExternalConnectionsEditPage}
            />
            <ProtectedRoute
                component={monitorRouterMatch(STORE_RULES_EXTERNAL_CONNECTIONS, () => {
                    return;
                })(WrappedRuleConnectionAdd)}
                path={RulesPagesNavigation.ExternalConnectionsAddPage}
            />
            <ProtectedRoute
                component={monitorRouterMatch(STORE_TAG_PREVIEW, (s, m) => s[STORE_TAG_PREVIEW].setItem(m!.params))(
                    TagPreviewPage
                )}
                path={RulesPagesNavigation.TagPreviewPage}
            />
            <ProtectedRoute
                component={monitorRouterMatch(STORE_RULE_EDIT, (s, m) => s[STORE_RULE_EDIT].setMatch(m!.params))(
                    RulePreviewPage
                )}
                path={RulesPagesNavigation.RulesPreviewPage}
            />
        </>
    );
};
